import React, { useState, useEffect } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';

const SaveEditFilterModel = ({ show, onHide, onSave, defaultValue = null, isUpdating, mode = 'save' }) => {
  const [viewName, setViewName] = useState('');
  const [setAsDefault, setSetAsDefault] = useState(false);

  useEffect(() => {
    if (show) {
      if (defaultValue) {
        setViewName(defaultValue.name || '');
        setSetAsDefault(defaultValue.isDefault || false);
      } else {
        setViewName('');
        setSetAsDefault(false);
      }
    }
  }, [show, defaultValue]);

  const handleSaveOrEdit = async () => {
    if (!viewName.trim()) {
      return;
    }
    await onSave({
      viewName: viewName.trim(),
      setAsDefault
    });
  };

  const handleClose = () => {
    setViewName('');
    setSetAsDefault(false);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static" style={{ zIndex: '99999' }}>
      <Modal.Header>
        <Modal.Title>
          <h6 className="mb-0 text-dark font-weight-bold">
            {defaultValue ? 'Rename Filter View' : 'Save Current View'}
          </h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="overflow-auto">
        <Form.Group className="mb-3">
          <Form.Label>
            View Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            value={viewName}
            required
            onChange={e => setViewName(e.target.value)}
            placeholder="Enter view name"
            autoFocus
            minLength={3}
            maxLength={50}
            disabled={isUpdating}
          />
        </Form.Group>
        {mode === 'save' && (
          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              checked={setAsDefault}
              onChange={e => setSetAsDefault(e.target.checked)}
              label="Set as default view"
              disabled={isUpdating}
            />
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button className="ml-2 px-2 text-dark" variant="outline-secondary" onClick={handleClose} disabled={isUpdating}>
          Cancel
        </Button>
        <Button
          disabled={!viewName.trim() || isUpdating}
          className="ml-2 px-2 d-inline-flex align-items-center justify-content-center"
          variant="primary"
          style={{
            backgroundColor: '#FACC14',
            borderColor: '#FACC14'
          }}
          onClick={handleSaveOrEdit}
        >
          {isUpdating && <Spinner size="sm" animation="border" className="mr-1" />}
          {isUpdating ? (defaultValue ? 'Updating...' : 'Saving...') : 'Save'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SaveEditFilterModel;
